import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { KeyRound, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const PasswordChangeOfferModal = () => {
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const open = !!user?.must_change_password;

  const handleSkip = async () => {
    setSubmitting(true);
    try {
      await api.post('/auth/skip-change-password');
      updateUser({ must_change_password: false });
    } catch (err) {
      toast.error('Gagal menyimpan pilihan, coba lagi');
    } finally {
      setSubmitting(false);
    }
  };

  const handleChangeNow = () => {
    navigate('/change-password');
  };

  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-sm"
        data-testid="password-change-offer-modal"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center mb-2">
            <KeyRound className="w-6 h-6 text-amber-600" />
          </div>
          <DialogTitle>Mau ganti password sekarang?</DialogTitle>
          <DialogDescription>
            Anda masih memakai password sementara. Ganti sekarang biar lebih mudah diingat, atau
            lanjut dulu pakai yang sekarang - tawaran ini tidak akan muncul lagi.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2 mt-2">
          <Button
            className="w-full"
            onClick={handleChangeNow}
            data-testid="offer-change-now-btn"
          >
            Ganti Sekarang
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={handleSkip}
            disabled={submitting}
            data-testid="offer-skip-btn"
          >
            {submitting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Nanti Saja
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
